import { render, staticRenderFns } from "./sdg-icon.vue?vue&type=template&id=c9538148&"
import script from "./sdg-icon.vue?vue&type=script&lang=js&"
export * from "./sdg-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports